// extracted by mini-css-extract-plugin
module.exports = {"root":"BackArrow_root__c1h_I","text":"BackArrow_text__392P5"};